import { Component, OnInit } from '@angular/core';

import { RandomMultiGeneratorConfig } from '@frontend/sports/common/client-config-data-access';
import { firstValueFrom, map } from 'rxjs';

import { BetGeneratorLoaderService } from '../../bet-generator/bet-generator-loader.service';
import { ComponentProxy } from '../../deferred/component-loader.service';
import { ComponentProxyDirective } from '../../deferred/component-proxy.directive';
import { WidgetComponent } from '../../widget/core/widget-registry.service';

@Component({
    selector: 'ms-bet-generator-shared-column',
    template: `
        @if (configuration?.isConfigReady && configuration?.isEnabled) {
            <ng-container *msComponentProxy="columnComponent"></ng-container>
        }
    `,
    imports: [ComponentProxyDirective],
})
export class BetGeneratorSharedColumnComponent extends WidgetComponent<never> implements OnInit {
    columnComponent: ComponentProxy | undefined;

    constructor(
        private loader: BetGeneratorLoaderService,
        public configuration: RandomMultiGeneratorConfig,
    ) {
        super();
    }

    async ngOnInit() {
        this.columnComponent = await firstValueFrom(
            this.configuration.whenReady.pipe(map(() => (this.configuration.isEnabled ? this.loader.getGeneratorColumnComponent() : undefined))),
        );
    }
}
